import { pdfjs } from "react-pdf";

// The one place the pdf.js worker is configured — the lightbox viewer and the
// attachment thumbnails share it, so both run on react-pdf's own pdf.js version.
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.mjs",
  import.meta.url,
).toString();

export { pdfjs };
